import "./home.scss"
import React, { useEffect, useState } from "react";
import Spline from "@splinetool/react-spline";
import { Link } from "react-scroll";
import cv from "../../Assets/pdf/cv.pdf";

export default function Home(){

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1200);

    useEffect(() => {
      const handleResize = () => setIsMobile(window.innerWidth <= 1200);
  
      window.addEventListener('resize', handleResize);
  
      return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div className="home-content ">
            {!isMobile&&
            (<div className="spline-div">
            <Spline
               scene="https://prod.spline.design/lLTN55nM4bPuqzy8/scene.splinecode" 
          />
            </div>)}
            <div className="content">
                <div className="details">
            <div className="flex-1">
                <span className="name">
                Hello! It's Jagadeeswarn
                </span>
                <span className="position-text ">
                I'm a  <span className="anim-typewriter line-1 position-sub"> Software Developer</span>
                </span>  </div>
                <p className="about-me">
                a passionate <span className="position">Full-Stack Developer</span>  with a knack for building innovative and efficient web applications. 
                 With a solid background in both front-end and back-end technologies.
                </p>
                <div className="actions">
                    <button className="see-more custom-button">
                    <Link to="about" smooth={true} duration={300}>
                    See More
                    </Link>
                      
                    </button>
                    <a href={cv} download="Jagadesh Resume" target='_blank'>
                    <button className="custom-button">
                        Download CV
                    </button></a>
                </div>
                </div>
       
            </div>
    </div>
      

    );
}